import React from 'react'
import { Card, Tabs } from 'antd';
import FoodTracking from './tabs/food-tracking';
import WeightTracking from './tabs/weight-tracking';
import ManuallyTracking from './tabs/manually-tracking';
import CONSTANTS from '../../../util/constant/CONSTANTS';
import DeviceDetails from './tabs/device-details';

const PetDetails = () => {
    const menus = {
        food: <FoodTracking />,
        weight: <WeightTracking />,
        manually: <ManuallyTracking />,
        device: <DeviceDetails />,
    };

    return (
        <>
            <div >

                <Card className="mt-5">
                    <Tabs
                        className="p-0 m-0"
                        defaultActiveKey="1"
                        size="middle"
                        type="card"
                        items={CONSTANTS.TAB_MENU.PET.map((ele) => {
                            return {
                                label: `${ele.Label}`,
                                key: `${ele.id}`,
                                children: menus[ele?.id],
                            };
                        })}
                    />
                </Card>
            </div>
        </>
    );
}

export default PetDetails